import styled from '@emotion/styled';
import { TableContainer } from '@mui/material';

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px 40px;
`;

export const DropTableContainer = styled(TableContainer)`
  max-height: 100%;
`;
